module.exports = __webpack_public_path__ + "static/media/icon-passport.78079fd5.svg";